import { DomainAssignmentState } from '../../typing';
import { parseDomain } from '../../utils';
import { PremiumMyDomainsApiClient, PremiumUserDomainApiClient } from '../ApiClients/ProtoServicesApiClients';
export const getDomainDataFromAccountParams = async _ref => {
  var _accountParams$assign, _accountParams$domain;
  let {
    httpClient,
    request
  } = _ref;
  const {
    parsedDomain: parsedDomainInput,
    domainName,
    accountParams,
    disableFetch
  } = request;
  const parsedDomain = parsedDomainInput ?? parseDomain(domainName);
  const {
    DomainsApiClient
  } = require('../ApiClients/DomainsApiClient');
  const isUnassigned = accountParams.unassignedDomains.find(domain => domain === parsedDomain.input);
  const assignedSite = (_accountParams$assign = accountParams.assignedDomains) == null ? void 0 : _accountParams$assign[parsedDomain.input];
  if (!isUnassigned && !assignedSite && !disableFetch) {
    return DomainsApiClient.query.domainData({
      httpClient,
      request: {
        parsedDomain
      }
    });
  }
  const domainDto = (_accountParams$domain = accountParams.domains) == null ? void 0 : _accountParams$domain.find(domain_ => domain_.domainName === parsedDomain.input);
  return {
    parsedDomain,
    assignmentState: isUnassigned ? DomainAssignmentState.UNASSIGNED : assignedSite ? DomainAssignmentState.ASSIGNED : DomainAssignmentState.NONE,
    assignedSiteName: assignedSite == null ? void 0 : assignedSite.siteName,
    assignedSiteId: assignedSite == null ? void 0 : assignedSite.siteId,
    domainDto
  };
};
export const getDomainDataWithAccountParams = async _ref2 => {
  let {
    httpClient,
    request
  } = _ref2;
  const {
    DomainsApiClient
  } = require('../ApiClients/DomainsApiClient');
  const accountParams = await DomainsApiClient.query.domainsAccount({
    httpClient,
    request: request.accountParamsRequest ?? {}
  });
  return getDomainDataFromAccountParams({
    httpClient,
    request: {
      ...request.domainDataRequest,
      accountParams,
      disableFetch: request.disableFetch
    }
  });
};
export const getUserDomain = async _ref3 => {
  let {
    httpClient,
    request: {
      domain,
      withSiteData = false
    }
  } = _ref3;
  const parsedDomain = domain.input ? domain : parseDomain(domain);
  try {
    const {
      domain: userDomain
    } = await PremiumUserDomainApiClient.query.get({
      httpClient,
      request: {
        domainName: parsedDomain.fullAsciiDomain
      }
    });
    if (withSiteData && userDomain != null && userDomain.siteId || userDomain != null && userDomain.redirectsTo && withSiteData) {
      let siteId = userDomain == null ? void 0 : userDomain.siteId;
      if (!siteId) {
        const {
          domain: redirectUserDomain
        } = await PremiumUserDomainApiClient.query.get({
          httpClient,
          request: {
            domainName: (userDomain == null ? void 0 : userDomain.redirectsTo) ?? ''
          }
        });
        siteId = redirectUserDomain == null ? void 0 : redirectUserDomain.siteId;
      }
      const site = await PremiumMyDomainsApiClient.query.getSite({
        httpClient,
        request: {
          msid: siteId ?? ''
        }
      });
      return {
        domain: userDomain,
        site
      };
    }
    return {
      domain: userDomain
    };
  } catch (error) {
    var _response;
    const httpErrorStatus = (_response = error.response) == null ? void 0 : _response.status;
    switch (httpErrorStatus) {
      case 403:
        return {
          error: 'belongsToAnotherAccount'
        };
      case 401:
        return {
          error: 'unauthorized'
        };
      case 404:
        return {
          error: 'notFound'
        };
      default:
        throw error;
    }
  }
};
//# sourceMappingURL=searchAggregations.js.map